export function createMoneda() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    ClaveErp: '',
    EsActivo: true,
    Simbolo: '',
    Clave2: '',
    Clave3: '',
    Decimales: 2,
    Orden: 0,
    Notas: ''
  };
}
